export class WebhooksApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getWebhooks() {
    return this.#http.get('/api/webhooks');
  }

  async createWebhook(body) {
    return this.#http.post('/api/webhooks', body);
  }

  async updateWebhook({ id, ...body }) {
    return this.#http.put(`/api/webhooks/${id}`, body);
  }

  async deleteWebhook({ id }) {
    return this.#http.delete(`/api/webhooks/${id}`);
  }

  async getWebhookEvents() {
    return this.#http.get('/api/webhooks/events');
  }

  async testWebhook({ id }) {
    return this.#http.post(`/api/webhooks/${id}/test`);
  }

  async getWebhookDeliveries(params) {
    return this.#http.get('/api/webhooks/deliveries', { params });
  }

  async getWebhookDelivery(id) {
    return this.#http.get(`/api/webhooks/deliveries/${id}`);
  }

  async replayWebhookDelivery(id) {
    return this.#http.post(`/api/webhooks/deliveries/${id}/replay`);
  }

  async replayWebhookDeliveries(deliveryIds) {
    return this.#http.post('/api/webhooks/deliveries/replay', { deliveryIds });
  }

  async getWebhookSettings() {
    return this.#http.get('/api/webhooks/settings');
  }

  async updateWebhookSettings(body) {
    return this.#http.put('/api/webhooks/settings', body);
  }
}
